import React from "react";
import { Col, Container, Row } from "reactstrap";
import "remixicon/fonts/remixicon.css";  // Import Remix Icons CSS

const Industries = () => {
  const industries = [
    {
      id: 1,
      title: "Steel Industry",
      icon: "ri-building-line fs-1",
      iconColor: "#60A5FA",
    },
    {
      id: 2,
      title: "Transport",
      icon: "ri-truck-line fs-1",
      iconColor: "#FF6347",
    },
    {
      id: 3,
      title: "Solvent Plant",
      icon: "ri-building-3-line fs-1",
      iconColor: "#2E8B57",
    },
    {
      id: 4,
      title: "Hotel Management",
      icon: "ri-hotel-line fs-1",
      iconColor: "#00BFFF",
    },
    {
      id: 5,
      title: "Restaurants",
      icon: "ri-restaurant-line fs-1",
      iconColor: "#FF6347",
    },
    {
      id: 6,
      title: "Wholesale",
      icon: "ri-store-2-line fs-1",
      iconColor: "#FF8C00",
    },
    {
      id: 7,
      title: "Retail",
      icon: "ri-store-line fs-1",
      iconColor: "#32CD32",
    },
    {
      id: 8,
      title: "Educational Institutions",
      icon: "ri-book-2-line fs-1",
      iconColor: "#32CD32",
    },
    {
      id: 9,
      title: "Supplier Management",
      icon: "ri-user-3-line fs-1",
      iconColor: "#1E90FF",
    },
    {
      id: 10,
      title: "Mall & Theater Management",
      icon: "ri-movie-line fs-1",
      iconColor: "#8A2BE2",
    },
  ];

  return (
    <React.Fragment>
      <section className="section bg-light" id="industries">
        <div className="bg-overlay bg-overlay-pattern"></div>
        <Container>
          <Row className="justify-content-center">
            <Col className="col-lg-8">
              <div className="text-center mb-5">
                <h1 className="mb-3 ff-secondary fw-semibold text-capitalize lh-base">
                  Industries <span className="text-primary">We Serve</span>
                </h1>
                <p className="text-muted mb-4">
                  We are Omnipresent
                </p>
              </div>
            </Col>
          </Row>

          {/* Row 1 */}
          <Row className="gy-5">
            {industries.slice(0, 4).map((industry) => (
              <Col lg={3} md={6} key={industry.id} className="d-flex">
                <div className="card text-center w-100">
                  <div className="card-body p-4">
                    <div className="avatar-sm position-relative mb-3 mx-auto">
                      <div className="job-icon-effect mb-3"></div>
                      <div
                        className="avatar-title bg-transparent rounded-circle"
                        style={{ color: industry.iconColor }}
                      >
                        <i className={industry.icon}></i> {/* Rendering the icon using class name */}
                      </div>
                    </div>
                    <h5 className="fs-17 mt-3 mb-3">{industry.title}</h5> {/* Added margin-bottom to the title */}
                    <a href="#!" className="btn btn-primary w-100 mt-3"> {/* Added margin-top to the button */}
                      View Profile
                    </a>
                  </div>
                </div>
              </Col>
            ))}
          </Row>

          {/* Row 2 */}
          <Row className="gy-5">
            {industries.slice(4, 8).map((industry) => (
              <Col lg={3} md={6} key={industry.id} className="d-flex">
                <div className="card text-center w-100">
                  <div className="card-body p-4">
                    <div className="avatar-sm position-relative mb-3 mx-auto">
                      <div className="job-icon-effect mb-3"></div>
                      <div
                        className="avatar-title bg-transparent rounded-circle"
                        style={{ color: industry.iconColor }}
                      >
                        <i className={industry.icon}></i> {/* Rendering the icon using class name */}
                      </div>
                    </div>
                    <h5 className="fs-17 mt-3 mb-3">{industry.title}</h5> {/* Added margin-bottom to the title */}
                    <a href="#!" className="btn btn-primary w-100 mt-3"> {/* Added margin-top to the button */}
                      View Profile
                    </a>
                  </div>
                </div>
              </Col>
            ))}
          </Row>

          {/* Row 3 */}
          <Row className="gy-5 align-content-center">
            <Col lg={3}></Col>
            {industries.slice(8).map((industry) => (
              <Col lg={3} md={6} key={industry.id} className="d-flex">
                <div className="card text-center w-100">
                  <div className="card-body p-4">
                    <div className="avatar-sm position-relative mb-3 mx-auto">
                      <div className="job-icon-effect mb-3"></div>
                      <div
                        className="avatar-title bg-transparent rounded-circle"
                        style={{ color: industry.iconColor }}
                      >
                        <i className={industry.icon}></i> {/* Rendering the icon using class name */}
                      </div>
                    </div>
                    <h5 className="fs-17 mt-3 mb-3">{industry.title}</h5> {/* Added margin-bottom to the title */}
                    <a href="#!" className="btn btn-primary w-100 mt-3"> {/* Added margin-top to the button */}
                      View Profile
                    </a>
                  </div>
                </div>
              </Col>
            ))}
            <Col lg={3}></Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default Industries;
